import {
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Select as ShadcnSelect,
} from '@bpinternal/ui-kit-next'
import { ComponentProps, ReactNode } from 'react'

type SelectItem = {
  type: 'item'
  value: string
  leadingIcon?: ReactNode
  disabled?: boolean
  content: ReactNode
}

type SelectSeparator = {
  type: 'separator'
}

export type SelectMenuItems = SelectItem | SelectSeparator

type TriggerProps = ComponentProps<typeof SelectTrigger>
type ContentProps = Pick<ComponentProps<typeof SelectContent>, 'color' | 'position' | 'side' | 'sideOffset'>

export type SelectProps = {
  items: SelectMenuItems[]
  className?: string
} & Pick<
  ComponentProps<typeof ShadcnSelect>,
  'value' | 'defaultValue' | 'onValueChange' | 'open' | 'disabled' | 'dir' | 'autoComplete'
> & {
    triggerColor?: TriggerProps['color']
  } & ContentProps &
  ComponentProps<'button'>

export const Select = ({
  ref,
  items,
  triggerColor,
  color,
  position = 'popper',
  side,
  sideOffset,
  className,
  value,
  defaultValue,
  onValueChange,
  open,
  disabled,
  dir,
  autoComplete,
  ...props
}: SelectProps) => (
  <ShadcnSelect {...{ value, defaultValue, onValueChange, open, disabled, dir, autoComplete }}>
    <SelectTrigger ref={ref} {...props} className={className} color={triggerColor}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent {...{ color, position, side, sideOffset }}>
      {items.map((item, index) => {
        if (item.type === 'separator') {
          return <SelectSeparator key={index} />
        }
        return (
          <SelectItem
            key={item.value}
            value={item.value}
            disabled={item.disabled}
            className="flex-row-reverse justify-end gap-2 px-3 *:relative *:last:grow"
          >
            <span>{item.content}</span>
          </SelectItem>
        )
      })}
    </SelectContent>
  </ShadcnSelect>
)

Select.displayName = 'Select'
